module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"check":"Вы не дали разрешение на доступ к камере или микрофону.","p1":"Слева от адреса сайта нажмите на значок перечёркнутой камеры или микрофона;","p2":"Сбросьте запрет на доступ к камере и микрофону;","p3":"Обновите страницу;","p4":"Нажмите Разрешить, когда браузер снова запросит доступ.","more":"Если рекомендации не помогли, воспользуйтесь","support":"документацией Firefox"}}')
  delete Component.options._Ctor
}
